import lodash from "lodash";
import Base from "../base.store";

const baseUrl = '/api/v1/transaction/inspections'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        reportData(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/data`, data, { ...config, responseType: "blob" });
        },
        riskProcess(context, { data, config }) {
            return base.request.post(`${baseUrl}/risk-process`, data, { ...config });
        }
    },
    mutations: {
        ...base.mutations
    },
}
